import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioSteps12And13And14And15 {
	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {
	}
	public locations = [
		{
			type: constants.placementType.wrong,
			position: 25,
		},
		{
			type: constants.placementType.close,
			position: 43,
		},
		{
			type: constants.placementType.correct1,
			position: 63,
		},
	];

	public start() {
		this.step12ShowBleedingControlKit();
	}

	step12ShowBleedingControlKit() {
		var context = this;
		context.mainScenario.doStuffIfStepsWereSkipped();
		context.mainScenario.playSequence("TransitionToUnsafe", null, () => {
		});
			context.mainScenario.playSound('5', '9', () => {
				var data = {
					disabled: true,
					onSelectionChanged: (index: number) => {
						if (index === 2) {
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
							context.mainScenario.playSequence('PutOnPPE', null, () => {
								context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
							});
							context.mainScenario.playSound('5', '11', () => {
								context.step13ShowBleedingControlKit();
							});
						}
					},
					disablePPEButton: false,
					disableTourniqueteButton: true,
					disablePressureDressingButton: true
				};
				context.mainScenario.playSound('5', '10', () => {
					data.disabled = false;
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
				});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select PPE.'});
				context.mainScenario.showTimer();
			});
	}

	step13ShowBleedingControlKit() {
		var context = this;
		var data = {
			disabled: true,
			onSelectionChanged: (index: number) => {
				if (index === 0) {
					context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
					context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
					context.mainScenario.playSequence('ApplyPressureSetup', null, () => {
						context.mainScenario.playSequence('ApplyPressure', null, () => {
						});
						context.mainScenario.playSequence('SetBloodParticlePercentage', {
							zeroPercent: true,
							twentyFivePercent: false,
							fiftyPercent: false,
							seventyFivePercent: false,
							oneHundredPercent: false
						});
						setTimeout(() => {
							context.mainScenario.playSequence('ApplyPressureEnd', null, () => {
							});
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: false,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: true
							});
							context.mainScenario.playSound('5', '13', () => {
								this.step14ShowBleedingControlKit();
							});
						}, 5000);
					});
				}
			},
			disablePPEButton: true,
			disableTourniqueteButton: true,
			disablePressureDressingButton: false
		};
		context.mainScenario.playSound('5', '12', () => {
			data.disabled = false;
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the pressure dressing.'});
	}
	step14ShowBleedingControlKit() {
		var context = this;
		var data = {
			disabled: true,
			onSelectionChanged: (index: number) => {
				if (index === 1) {
					context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
					context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
					context.step15TourniqueteDragDrop();
				}
			},
			disablePPEButton: true,
			disableTourniqueteButton: false,
			disablePressureDressingButton: true
		};
		context.mainScenario.playSound('5', '14', () => {
			data.disabled = false;
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the tourniquet.'});
	}
	step15TourniqueteDragDrop() {
		var context = this;
		this.mainScenario.playSequence('TourniqueteSetup', null, () => {
			var onDone = () => {
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the tourniquet to the correct location. KB - Tab to cycle placements, use spacebar to select the location.'});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
					dispatch: this.mainScenario.gameManager.customData.dispatch,
					locations: context.locations,
					correctIndex1: 1,
					onDone: (selectedNumber: number, isCorrect: boolean) => {
						if (isCorrect) {
							context.mainScenario.gameManager.UiManager.hideaAllUis();
							context.mainScenario.playSound('5', '15', () => {
								context.step2TryAgain()
							});
						}
					}
				});
			};
			onDone();
		});
	}

	private step2TryAgain() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to try again?',
			correctButton: {
				title: 'Try Again',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Next',
				greyedOut: true,
				onClick: () => { }
			}
		});
		context.mainScenario.playSound('5', '16', () => {
		});
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						onClick: () => context.step12ShowBleedingControlKit()
					},
					incorrectButton: {
						title: 'Next',
						onClick: () => context.step2TryAgainAfter()
					}
				});

	}

	private step2TryAgainAfter() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.onDone();
	}

}